module.exports = __webpack_public_path__ + "img/cloud-hail-moon.5985157c.svg";